module.exports = __webpack_public_path__ + "img/Credit-One-BG.8e2f4895.jpg";